<template>
  <Menu width="auto" :accordion="true" :open-names="openMenus" @on-select="getSelect">
    <Submenu v-for="(g, i) in groups" v-if="menus[i].is_show" :key="i" :name="i">
      <template slot="title">
        <i :class="`fa ${menus[i].icon}`"></i>
        {{ menus[i].name }}
      </template>
      <MenuItem v-for="c in g" v-if="menus[c].is_show" :key="c" :name="c">{{ menus[c].name }}</MenuItem>
    </Submenu>
  </Menu>
</template>
<script>
  export default {
    name: 'menu_bar',
    data() {
      return {
        menus: null,
        groups: null,
        openMenus: [],
        menuKeys: []
      }
    },
    created() {
      this.getData()
    },
    methods: {
      getData () {
        let user = Lockr.get('user')
        //console.log(user)
        this.groups = user.group.content.cid
        //console.log(JSON.stringify(this.groups));
        this.menus = Lockr.get('menus')
        //console.log(JSON.stringify(this.menus));
        for (var key in this.groups) {
            this.menuKeys.push(key)
        }
        this.openMenus.push(this.menuKeys[0])
      },
      getSelect (e) {
        this.$router.push({ name: this.menus[e].router })
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/Common/MenuBar.vue